
import { IoIosStar } from "react-icons/io";

const Star = ({star=5}) => {

    return (
        Array.from({length:star}).map((item,index) => {
            return <IoIosStar className={'star'} key={index} color='#ff8c00' size={24} />
        })
    )
};

export default Star;